import * as React from 'react';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { GridCellParams, GridColumns } from '@material-ui/data-grid';
import { IconButtonSession } from '@screens/players/player.details.tabs/sessions/player.session.button';
import { useGame } from '@domain/game.selection/game.selection.hook';

const columns: GridColumns = [
  { field: 'sessionId', headerName: 'Session', width: 130 },
  { field: 'gameSessionId', headerName: 'Game Session', width: 180 },
  { field: 'versionTag', headerName: 'Version', width: 130 },
  { field: 'gameId', headerName: 'Game', width: 130 },
  { field: 'startDate', headerName: 'Start', width: 180, ...formatColWithDate },
  { field: 'updateDate', headerName: 'End', width: 180, ...formatColWithDate },
  {
    field: 'id',
    headerName: ' ',
    width: 50,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params: GridCellParams) => <IconButtonSession params={params.row} />,
  },
];

const columnsWithAppCode: GridColumns = [
  { field: 'appcode', headerName: 'App Code', width: 150, renderCell: (params: GridCellParams) => <>{params.value === 1 ? 'Classic' : 'PNew'}</> },
  ...columns,
];

interface PlayerSessions {
  sessionId: number;
  gameSessionId: number;
  versionTag: string;
  gameId: number;
  startDate: string;
  updateDate: string;
  appcode?: number;
}

let index = 0;
function createData(session: PlayerSessions) {
  index += 1;
  return { id: index, ...session };
}

const PlayerSessions = ({ player }: PlayerDataProps) => {
  const game = useGame();
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<PlayerSessions[]>(`/admin/sessions/player/${requestPid}`, { params: { page }, cancelToken });
  }

  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });

  const rows = responseData?.map(createData) || [];

  return (
    <TabTableContainer>
      <MainDataGrid columns={game.useAppCode ? columnsWithAppCode : columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
    </TabTableContainer>
  );
};

export default PlayerSessions;
